import { FieldValidatorType } from "@progress/kendo-react-form";

//const regex = new RegExp(/^(\+\d{1,3}[- ]?)?\d{9,11}$/);
const regex = new RegExp(/^\+?[\d \-([)\]]+$/);

export const phoneNumberValidator: FieldValidatorType = (value: string) =>
  (regex.test(value) || value === "" || value===undefined) ? "" : "Il campo deve contenere un numero di telefono valido";
//(Es. +393470040405, 3470040405, 347-0040405)";
